import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { INVITE_PRICES } from '../utils/pricing';

const LOGO = '/dailyreps3.png';

const FEATURES = [
  'Full video drill library',
  'AI-written descriptions',
  'Daily reinforcement questions',
  'Streaks, points, and shields',
  'Badges and team leaderboard',
  'Challenge days and bonus points',
];

export default function CoachOrder() {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  // Affiliate tracking
  useEffect(() => {
    const s = document.createElement('script');
    s.src = 'https://affiliate-platform-production-f4fa.up.railway.app/track.js?pid=cmtdislyw024r2tx3gmysyb0g&v=1';
    s.async = true;
    document.head.appendChild(s);
    return () => { document.head.removeChild(s); };
  }, []);

  // Capture trialxyz param for testing shorter trials
  useEffect(() => {
    const t = searchParams.get('trialxyz');
    if (t) localStorage.setItem('trialxyz', t);
  }, []); // eslint-disable-line

  return (
    <div className="order-page">
      <header className="order-header"><div className="order-wrap">
        <div className="order-logo-row">
          <img src={LOGO} alt="Train Daily" className="order-logo" />
          <span className="order-brand">Train Daily</span>
        </div>
        <a href="https://www.traindaily.com/coaches" className="order-nav-link">For Coaches</a>
      </div></header>

      <main className="order-main"><div className="order-wrap">
        <p className="order-eyebrow">Get started</p>
        <h1 className="order-title">
          Free for <span className="accent">Coaches</span>
        </h1>
        <p className="order-lead">
          Set up your team for free. Parents sign up and pay for their own player.
        </p>

        <div className="order-cards">
          <div className="order-card">
            <h3>Free for you</h3>
            <div className="order-card-subtitle">Parents pay per player</div>
            <div className="order-price">$0</div>
            <div className="order-price-per">for you, the coach</div>
            <div className="order-price-billed">Parents pay {INVITE_PRICES.parent_pays.monthly}/player/mo or {INVITE_PRICES.parent_pays.annual}/player/yr</div>
            <ul className="order-features">
              {FEATURES.map((f, i) => (
                <li key={i}><i className="fas fa-check"></i> {f}</li>
              ))}
            </ul>
            <button className="btn btn-primary order-btn" onClick={() => {
              const t = searchParams.get('trialxyz') || localStorage.getItem('trialxyz');
              navigate(`/coaches/setup${t ? '?trialxyz=' + t : ''}`);
            }}>
              Get Started Free
            </button>
          </div>
        </div>

        <p className="order-fine">
          Create your account for free. Then generate invite links for your players' families.
          Each family pays their own subscription — you manage the training.
        </p>

        <p className="order-fine" style={{ marginTop: 12 }}>
          Have a club with 25+ players? <a href="https://app.traindaily.com/club/order-yearly" style={{ color: '#f77c00', fontWeight: 600, textDecoration: 'underline' }}>Check out our club pricing</a>
        </p>
      </div></main>

      <footer className="order-footer"><div className="order-wrap">
        <p>&copy; Train Daily. Built by Outsmart Press, Inc.</p>
      </div></footer>
    </div>
  );
}
